<template>
  <div class="fy-calendar">
    <input
      :placeholder="placeholder"
      :readonly="is_readonly"
      @click="open('picker')"
      type="text"
      v-model="currentValue"
    >
    <mt-datetime-picker
      :closeOnClickModal="false"
      :end-date="end_date"
      :start-date="start_date"
      :type="type"
      @confirm="handleChange"
      @visible-change="handleVisibleChange"
      ref="picker"
      v-model="norm_date"
    ></mt-datetime-picker>
  </div>
</template>
<script>
//TODO [xsw] 日期选择组件是否还需要加验证？？
import util from '../utils/util.js'
import { DatetimePicker } from 'mint-ui'   //mint-ui组件
export default {
  name: 'MobileDate',
  componentName: 'MobileDate',
  components: {
    MtDatetimePicker: DatetimePicker
  },
  mixins: [util], //这些混入实例对象可以像正常的实例对象一样包含选项（可以直接this.*使用混入对象中的方法）
  inject: {
    //获取父元素的provide中的值
    fyForm: {
      default: ''
    },
    fyFormItem: {
      default: ''
    }
  },
  data () {
    return {
      //3种格式的日期
      is_init: true,
      currentValue: this.timestampToDate(this.value),  //日期标准字符串:2018-11-1
      timestamp: this.value,  //时间戳
      norm_date: this.value ? this.timestampToNormDate(this.value) : this.timestampToNormDate(this.default_anchor) //标准时间:Thu Mar 19 2015 12:00:00 GMT+0800 (中国标准时间)
    }
  },
  props: {
    //默认开始位置（注意：不是指范围）
    default_anchor: {
      type: Number,
      default: new Date().getTime()
    },
    //选择日期的三种类型：'datetime', 'date', 'time',(暂时只支持选择年月日)
    type: {
      type: String,
      default: 'date'
    },
    placeholder: {
      type: String,
      default: '请选择日期'
    },
    is_readonly: {
      type: Boolean,
      default: true
    },
    //时间戳（数值）格式,没有默认值传0
    value: {
      type: Number,
      default: 0
    },
    start_date: {
      type: Date,
    },
    end_date: {
      type: Date
    }
  },
  mounted () {
    this.dispatch('FyFormItem', 'formItem.addChildVc', [this]) //发送添加formitem对象的信息
  },
  watch: {
    value (value) {
      this.setCurrentValue(this.value)
    },
    norm_date (value) {
      if (!this.is_init) {
        this.$emit('input', this.dateToTimestamp(value))
        this.dispatch('FyFormItem', 'el.form.change', [this.dateToTimestamp(value)])
        this.currentValue = this.formatDate(value)
      }
    }
  },
  filters: {
    //以下参数都为字符串
    //时间戳转日期
    timestampToDate: function (value) {
      if (value == 0 || value.constructor != Number) {
        return ''
      }
      if (value.toString().length <= 10) {
        value = value * 1000
      }
      const date = new Date(value)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      const s = y + '-' + m + '-' + d
      return y + '-' + m + '-' + d
    },
    //日期转时间戳
    dateToTimestamp (value) {
      // const reg = /^(\d{4})-(\d{2})-(\d{2})$/
      // if (!reg.test(value)) {
      //   return 0
      // } else {
      //   return new Date(value).getTime()
      // }
      return new Date(value).getTime()
    },
    //日期格式(Thu Mar 19 2015 12:00:00 GMT+0800 (中国标准时间))转为日期标准字符串：2015-03-19
    formatDate: function (value) {
      const date = new Date(value)
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + '-' + m + '-' + d;
    },
    //转标准时间
    normDate: function (date) {
      var t = Date.parse(date);
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, "/")));
      } else {
        return new Date();
      }
    },
    //时间戳转标准时间
    timestampToNormDate: function (value) {
      if (!isNaN(value)) {
        return new Date(Date.parse(date.replace(/-/g, "/")));
      } else {
        return new Date();
      }
    }
  },
  methods: {
    //打开日期选择弹出
    open (picker) {
      this.is_init = false
      this.$refs[picker].open();
    },
    //日期弹窗显示隐藏时的回调
    handleVisibleChange (isVisible) {
    },
    //选择日期后的回调
    handleChange (value) {
    },
    setCurrentValue (value) {
      if (value === this.timestamp) return // 如果新旧值一致直接返回
      this.timestamp = value
      this.currentValue = this.timestampToDate(this.value) //改变当前值
    },

    //时间格式处理的方法,以下参数都为字符串
    //时间戳转日期
    timestampToDate: function (value) {
      if (value == 0 || value.constructor != Number) {
        return ''
      }
      if (value.toString().length <= 10) {
        value = value * 1000
      }
      const date = new Date(value)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      const s = y + '-' + m + '-' + d
      return y + '-' + m + '-' + d
    },
    //日期转时间戳
    dateToTimestamp (value) {
      // const reg = /^(\d{4})-(\d{2})-(\d{2})$/
      // if (!reg.test(value)) {
      //   return 0
      // } else {
      //   return new Date(value).getTime()
      // }
      if (value) {
        return new Date(value).getTime()
      } else {
        return 0
      }
    },
    //日期格式(Thu Mar 19 2015 12:00:00 GMT+0800 (中国标准时间))转为日期标准字符串：2015-03-19
    formatDate: function (value) {
      if (value) {
        const date = new Date(value)
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
      }
      return ''
    },
    //转标准时间
    normDate: function (date) {
      var t = Date.parse(date);
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, "/")));
      } else {
        return '';
      }
    },
    //时间戳转标准时间
    timestampToNormDate: function (value) {
      if (!isNaN(value)) {
        return new Date(value);
      } else {
        return '';
      }
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/components/form/form.css';
</style>



// WEBPACK FOOTER //
// src/components/form/mobileDate.vue